export const IDP_APPS = 'EDUCATIONAL_CONTENT';
